
import { computed, defineComponent, onMounted, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useStore } from "vuex";
import * as Yup from "yup";

// interface ProfileDetails {
//   avatar: string;
//   name: string;
//   surname: string;
//   company: string;
//   contactPhone: string;
//   companySite: string;
//   country: string;
//   language: string;
//   timezone: string;
//   currency: string;
//   communications: {
//     email: boolean;
//     phone: boolean;
//   };
//   allowMarketing: boolean;
// }
export default defineComponent({
  name: "account-settings",
  components: {
    ErrorMessage,
    Field,
    Form,
  },

  setup() {
    const store = useStore();
    const submitButton1 = ref<HTMLElement | null>(null);
    const submitButton2 = ref<HTMLElement | null>(null);
    const submitButton3 = ref<HTMLElement | null>(null);
    const submitButton4 = ref<HTMLElement | null>(null);
    const submitButton5 = ref<HTMLElement | null>(null);
    const updateEmailButton = ref<HTMLElement | null>(null);
    const updatePasswordButton = ref<HTMLElement | null>(null);

    const emailFormDisplay = ref(false);
    const passwordFormDisplay = ref(false);
    const typeFieldPassword = ref ("password");
    const showPasswords = function () {
        "password" == typeFieldPassword?.value? typeFieldPassword.value = "input": typeFieldPassword.value = "password";
    }

    const profileDetailsValidator = Yup.object().shape({
      title: Yup.string().required().label("Title"),
      fname: Yup.string().required().label("First name"),
      lname: Yup.string().required().label("Last name"),
      phone: Yup.string().required().label("Contact phone"),
    });

    const changeEmail = Yup.object().shape({
      updateEmailAddress: Yup.string()
        .min(4)
        .required().email().label("Email")
        .matches(/^[a-zA-Z0-9_.+-]+@gannon\.edu$/, 'Please enter Gannon email address'),
      confirmemailpassword: Yup.string().required().label("Password"),
    });

    const changePassword = Yup.object().shape({
      currentpassword: Yup.string().required().label("Current password"),
      newpassword: Yup.string()
        .min(6)
        .required()
        .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Must contain at least one number')
        .matches(/[^A-Za-z0-9]/, 'Must contain at least one special character')
        .label("Password"),
      confirmpassword: Yup.string()
        .min(6)
        .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Must contain at least one number')
        .matches(/[^A-Za-z0-9]/, 'Must contain at least one special character')
        .required()
        .oneOf([Yup.ref("newpassword"), null], "Passwords must match")
        .label("Password Confirmation"),
    });

    // const profileDetails = ref<ProfileDetails>({
    //   avatar: "media/avatars/150-2.jpg",
    //   name: "Max",
    //   surname: "Smith",
    //   company: "Keenthemes",
    //   contactPhone: "044 3276 454 935",
    //   companySite: "keenthemes.com",
    //   country: "MY",
    //   language: "msa",
    //   timezone: "Kuala Lumpur",
    //   currency: "USD",
    //   communications: {
    //     email: false,
    //     phone: false,
    //   },
    //   allowMarketing: false,
    // });

    const saveChanges1 = (values) => {
      if (submitButton1.value) {
        // Activate indicator
        submitButton1.value.setAttribute("data-kt-indicator", "on");
        // Update profile information
        store
          .dispatch(Actions.UPDATE_PROFILE, values)
          .then(() => {
            Swal.fire({
              text: "Your profile information has been updated successfully.",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(function () {
              window.location.reload();
            });
          })
          .catch(() => {
            submitButton1.value?.removeAttribute("data-kt-indicator");
            Swal.fire({
              text: store.getters.getErrors[0],
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Your profile information could not be updated !",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          });
        setTimeout(() => {
          submitButton1.value?.removeAttribute("data-kt-indicator");
        }, 2000);
      }
    };

    const saveChanges2 = () => {
      if (submitButton2.value) {
        // Activate indicator
        submitButton2.value.setAttribute("data-kt-indicator", "on");

        setTimeout(() => {
          submitButton2.value?.removeAttribute("data-kt-indicator");
        }, 2000);
      }
    };

    const saveChanges3 = () => {
      if (submitButton3.value) {
        // Activate indicator
        submitButton3.value.setAttribute("data-kt-indicator", "on");

        setTimeout(() => {
          submitButton3.value?.removeAttribute("data-kt-indicator");
        }, 2000);
      }
    };

    const saveChanges4 = () => {
      if (submitButton4.value) {
        // Activate indicator
        submitButton4.value.setAttribute("data-kt-indicator", "on");

        setTimeout(() => {
          submitButton4.value?.removeAttribute("data-kt-indicator");
        }, 2000);
      }
    };

    const deactivateAccount = () => {
      if (submitButton5.value) {
        // Activate indicator
        submitButton5.value.setAttribute("data-kt-indicator", "on");

        setTimeout(() => {
          submitButton5.value?.removeAttribute("data-kt-indicator");

          Swal.fire({
            text: "Email is successfully changed!",
            icon: "success",
            confirmButtonText: "Ok",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-light-primary",
            },
          }).then(() => {
            emailFormDisplay.value = false;
          });
        }, 2000);
      }
    };

    const updateEmail = (values) => {
      if (updateEmailButton.value) {
        // Activate indicator
        updateEmailButton.value.setAttribute("data-kt-indicator", "on");
        // Update email address
        store
          .dispatch(Actions.UPDATE_EMAIL, values)
          .then(() => {
            Swal.fire({
              text: "Your new email address has been updated successfully. Your user name has been updated, PLEASE LOGIN AGAIN.",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(function () {
              window.location.reload();
            });
          })
          .catch(() => {
            submitButton1.value?.removeAttribute("data-kt-indicator");
            Swal.fire({
              text: store.getters.getErrors[0],
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Your new email address could not be updated !",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            }).then(function () {
              window.location.reload();
            });
          });
        setTimeout(() => {
          updateEmailButton.value?.removeAttribute("data-kt-indicator");
          emailFormDisplay.value = false;
        }, 1000);
      }
    };

    const updatePassword = (values) => {
      if (updatePasswordButton.value) {
        // Activate indicator
        updatePasswordButton.value.setAttribute("data-kt-indicator", "on");
        // Update password
        store
          .dispatch(Actions.UPDATE_PASSWORD, values)
          .then(() => {
            Swal.fire({
              text: "Password is successfully changed!",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(function () {
              window.location.reload();
            });
          })
          .catch(() => {
            updatePasswordButton.value?.removeAttribute("data-kt-indicator");
            Swal.fire({
              text: store.getters.getErrors[0],
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Unfortunately, Password is not changed! Please check it and try again",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            }).then(function () {
              window.location.reload();
            });
          });
        setTimeout(() => {
          updatePasswordButton.value?.removeAttribute("data-kt-indicator");
          passwordFormDisplay.value = false;
        }, 1000);
      }
    };

    // const removeImage = () => {
    //   profileDetails.value.avatar = "media/avatars/blank.png";
    // };

    const currentUser = computed(() => {
      return store.getters.currentUser;
    });

    onMounted(() => {
      setCurrentPageBreadcrumbs("Settings", ["Account"]);
    });

    return {
      submitButton1,
      submitButton2,
      submitButton3,
      submitButton4,
      submitButton5,
      saveChanges1,
      saveChanges2,
      saveChanges3,
      saveChanges4,
      deactivateAccount,
      // profileDetails,
      emailFormDisplay,
      passwordFormDisplay,
      // removeImage,
      profileDetailsValidator,
      changeEmail,
      changePassword,
      updateEmailButton,
      updatePasswordButton,
      updateEmail,
      updatePassword,
      currentUser,
      showPasswords,
      typeFieldPassword,
    };
  },
});
